import { PostgrestError } from "@supabase/supabase-js";
import { DozenSupabaseClient, Tables } from "../../database.types";

const profileService = {
  async getProfile(
    supabase: DozenSupabaseClient,
    userId: string,
  ): Promise<Tables<"profiles"> | null> {
    const { data, error } = await supabase
      .from("profiles")
      .select("*")
      .eq("id", userId)
      .single();

    if (error) throw error;
    return data;
  },

  async updateProfileName(
    supabase: DozenSupabaseClient,
    userId: string,
    name: string,
  ): Promise<PostgrestError | null> {
    const { error } = await supabase
      .from("profiles")
      .update({
        name,
      })
      .eq("id", userId);

    return error;
  },
};

export default profileService;
